import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "alm-deployment-modal-body" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "alm-deployment-modal-details" }
const _hoisted_4 = { class: "alm-deployment-modal-details-title" }
const _hoisted_5 = { class: "alm-deployment-modal-details-text" }
const _hoisted_6 = { class: "alm-deployment-modal-details" }
const _hoisted_7 = { class: "alm-deployment-modal-details-title" }
const _hoisted_8 = { class: "alm-deployment-modal-details-text" }
const _hoisted_9 = { class: "alm-deployment-modal-details" }
const _hoisted_10 = { class: "alm-deployment-modal-details-title" }
const _hoisted_11 = { class: "alm-deployment-modal-details-text" }
const _hoisted_12 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_button = _resolveComponent("f-button")!
  const _component_f_modal = _resolveComponent("f-modal")!

  return (_openBlock(), _createBlock(_component_f_modal, {
    visible: _ctx.isVisible,
    class: "alm-deployment-modal",
    title: _ctx.localizer.Localize('LandscapeManagement_Changeset_Deployment_Modal_Header_Text'),
    "onUpdate:visible": _cache[1] || (_cache[1] = (vis) => _ctx.setVisible(vis))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_f_button, {
          text: "Button",
          type: "default",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.localizer.Localize("Cancel_PascalCase")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_f_button, {
          text: "Button",
          type: "primary",
          onClick: _ctx.confirmDeployment
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.localizer.Localize("LandscapeManagement_Deploy_Text")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", {
          class: "alm-deployment-modal-subheader",
          innerHTML: _ctx.localizer.FormatParameterizedLocalize('LandscapeManagement_Changeset_Deployment_Modal_Text', [_ctx.currentChangeset?.name])
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Objects')), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.currentChangeset?.count ? _ctx.currentChangeset?.count : ''), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Changeset_Source')), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.currentChangeset?.source ? _ctx.currentChangeset?.source : ''), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Changeset_Target')), 1),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.getTargetTenant()), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}